"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _table = require("baseui/table");

var _utils = require("../utils");

var _geojsonutils = require("../geojsonutils");

var _GenericPlotly = _interopRequireDefault(require("./showcases/GenericPlotly"));

var _d3Scale = require("d3-scale");

var _Constants = require("../Constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var WIDTH = 220;
var BAR_HEIGHT = 80;

var Tooltip = function (_React$Component) {
  _inherits(Tooltip, _React$Component);

  var _super = _createSuper(Tooltip);

  function Tooltip(props) {
    var _this;

    _classCallCheck(this, Tooltip);

    _this = _super.call(this);
    _this.state = {
      isMobile: props.isMobile
    };
    _this._listPropsAndValues = _this._listPropsAndValues.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this._handleWindowSizeChange.bind(this));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this._handleWindowSizeChange.bind(this));
    }
  }, {
    key: "_handleWindowSizeChange",
    value: function _handleWindowSizeChange() {
      this.forceUpdate();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          topx = _this$props.topx,
          topy = _this$props.topy,
          hoveredObject = _this$props.hoveredObject,
          _this$props$column = _this$props.column1,
          column1 = _this$props$column === void 0 ? "accident_severity" : _this$props$column,
          _this$props$column2 = _this$props.column2,
          column2 = _this$props$column2 === void 0 ? "date" : _this$props$column2;
      var isMobile = this.state.isMobile;
      if (!hoveredObject) return null;
      var type_feature = hoveredObject.type && hoveredObject.type === 'Feature';
      var cluster = hoveredObject && hoveredObject.cluster;
      var severity_data_separate = [];

      if (!type_feature && !cluster) {
        var severity_keys = column1 && (0, _geojsonutils.getPropertyValues)({
          features: hoveredObject.points.map(function (e) {
            return e.source;
          })
        }, column1);
        var severity_by_year = column1 && column2 && (0, _geojsonutils.propertyCountByProperty)(hoveredObject.points.map(function (e) {
          return e.source;
        }), column1, column2);
        severity_keys && severity_keys.forEach(function (name, i) {
          Object.keys(severity_by_year).forEach(function (y) {
            if (y && severity_by_year[y][name]) {
              if (!severity_data_separate[i]) {
                severity_data_separate[i] = {
                  x: [],
                  y: [],
                  name: name,
                  marker: {
                    color: (0, _d3Scale.scaleSequential)(_Constants.TURQUOISE_RANGE)(i / severity_keys.length)
                  }
                };
              }

              severity_data_separate[i].x.push(y);
              severity_data_separate[i].y.push(severity_by_year[y][name]);
            }
          });
        });
        severity_data_separate.map(function (e) {
          if (e.x.length > 1) {
            e.mode = 'lines';
          }
        });
      }

      var w = window.innerWidth;
      var y = window.innerHeight;
      var n_topy = isMobile ? 10 : topy + (WIDTH + BAR_HEIGHT) > y ? topy - WIDTH : topy;
      var n_left = isMobile ? 10 : topx + WIDTH > w ? topx - WIDTH : topx;

      var tooltip = _react["default"].createElement("div", {
        className: "xyz",
        style: {
          top: topy + (WIDTH + BAR_HEIGHT) > y ? n_topy : topy,
          left: topx + WIDTH > w ? n_left : topx
        }
      }, _react["default"].createElement("div", null, _react["default"].createElement("b", null, "Total: ", cluster ? hoveredObject.point_count : type_feature ? 1 : hoveredObject.points.length)), _react["default"].createElement("div", null, !cluster && (type_feature || hoveredObject.points.length <= 2) ? this._listPropsAndValues(hoveredObject) : _react["default"].createElement(_GenericPlotly["default"], {
        title: "".concat((0, _utils.humanize)(column1), " by ").concat((0, _utils.humanize)(column2)),
        width: WIDTH,
        data: severity_data_separate,
        dark: true,
        xaxis: {
          tickformat: 'd',
          showgrid: false
        },
        yaxis: {
          showgrid: false
        }
      })));

      return tooltip;
    }
  }, {
    key: "_listPropsAndValues",
    value: function _listPropsAndValues(hoveredObject) {
      var all = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 6;
      if (!hoveredObject.properties || hoveredObject.points && (!hoveredObject.points || !hoveredObject.points[0].properties)) return null;
      var DATA = [];
      var props = hoveredObject.properties;

      if (props) {
        var keys = Object.keys(props);
        DATA = keys.slice(0, all ? keys.length : n).map(function (p) {
          return [(0, _utils.humanize)(p), props[p]];
        });
      } else {
        var _keys = Object.keys(hoveredObject.points[0].properties);

        DATA = _keys.slice(0, all ? _keys.length : n).map(function (p) {
          var points = [(0, _utils.humanize)(p), hoveredObject.points[0].properties[p]];

          if (hoveredObject.points[1]) {
            points.push(hoveredObject.points[1].properties[p]);
          }

          return points;
        });
      }

      return _react["default"].createElement(_table.Table, {
        style: {
          maxWidth: '320px'
        },
        columns: hoveredObject.points && hoveredObject.points.length === 2 ? ['Property', 'Value p1', 'Value p2'] : ['Property', 'Value'],
        data: DATA
      });
    }
  }]);

  return Tooltip;
}(_react["default"].Component);

exports["default"] = Tooltip;